import { Injectable } from '@angular/core';

@Injectable()
export class ToastService {

	private readonly INFO_CLASS = 'bg-info';
	private readonly SUCCESS_CLASS = 'bg-success';
	private readonly WARNING_CLASS = 'bg-warning';
	private readonly DANGER_CLASS = 'bg-danger';

	private enabled: boolean = true;

	constructor() {
	}

	public toasts: any[] = [];

	public info( body: string, header?: string ) {
		this.show( body, header, this.INFO_CLASS );
	}

	public success( body: string, header?: string) {
		this.show( body, header, this.SUCCESS_CLASS );
	}

	public warning(body: string, header?: string) {
		this.show( body, header, this.WARNING_CLASS );
	}

	public danger( body: string, header?: string) {
		this.show( body, header, this.DANGER_CLASS );
	}

	private show( body: string, header: string, colorClass: string ) {
		if( this.enabled )
			this.toasts.push({
				body,
				header,
				className: colorClass + ' text-light toast-notification'
			});
	}

	public remove( toast ) {
		this.toasts = this.toasts.filter(t => t != toast);
	}

	public disable() {
		this.enabled = false;
	}

	public enable() {
		this.enabled = true;
	}

}